export default {
  'financialAdministration.title': 'Administración financiera',
  'financialAdministration.description':
    'Pagos de clientes, obligaciones de comisión y liquidaciones del hub comercial.',
  'financialAdministration.tabs.overview': 'Resumen',
  'financialAdministration.tabs.payments': 'Pagos',
  'financialAdministration.tabs.ledgers': 'Obligaciones de comisión',
  'financialAdministration.tabs.settlements': 'Liquidaciones',
  'financialAdministration.tabs.beneficiary': 'Historial del beneficiario',
  'financialAdministration.filters.currency': 'Moneda',
  'financialAdministration.filters.apply': 'Aplicar',
  'financialAdministration.filters.clear': 'Limpiar',
  'financialAdministration.filters.dateRange': 'Rango de fechas',
  'financialAdministration.filters.saleRange': 'Fecha de venta',
  'financialAdministration.filters.eligibilityRange': 'Fecha de elegibilidad',
  'financialAdministration.filters.paymentRange': 'Fecha efectiva de pago',
  'financialAdministration.filters.generatedRange': 'Generada',
  'financialAdministration.filters.paidRange': 'Pagada',
  'financialAdministration.filters.companyId': 'Id de empresa que paga',
  'financialAdministration.filters.subscriptionId': 'Id de suscripción',
  'financialAdministration.filters.provider': 'Proveedor',
  'financialAdministration.filters.status': 'Estado',
  'financialAdministration.filters.discounted': 'Con descuento',
  'financialAdministration.filters.discounted.true': 'Con descuento',
  'financialAdministration.filters.discounted.false': 'Sin descuento',
  'financialAdministration.filters.beneficiaryCompanyId': 'Id de empresa beneficiaria',
  'financialAdministration.filters.beneficiaryActorKind': 'Tipo de beneficiario',
  'financialAdministration.filters.agreementId': 'Id de acuerdo',
  'financialAdministration.filters.revenueType': 'Tipo de ingreso',
  'financialAdministration.filters.derivedState': 'Estado derivado',
  'financialAdministration.filters.paymentDisposition': 'Disposición de pago',
  'financialAdministration.filters.settlementId': 'Id de liquidación',
  'financialAdministration.filters.ruleFrequency': 'Frecuencia de regla',
  'financialAdministration.error.dates': 'Desde debe ser anterior a hasta (UTC, semiabierto).',
  'financialAdministration.error.page': 'Tamaño de página inválido.',
  'financialAdministration.error.missingBeneficiary': 'Indique el id de la empresa beneficiaria.',
  'financialAdministration.overview.axis.payment': 'Pagos confirmados (fecha efectiva de pago)',
  'financialAdministration.overview.axis.saleGenerated':
    'Comisión generada y omitida (fecha de venta)',
  'financialAdministration.overview.axis.eligibility': 'Vence / elegible (fecha de elegibilidad)',
  'financialAdministration.overview.axis.settlementOpen': 'Liquidaciones abiertas (generada)',
  'financialAdministration.overview.axis.settlementPaid': 'Liquidaciones pagadas (pagada)',
  'financialAdministration.overview.axis.inconsistent': 'Filas inconsistentes (fecha de venta)',
  'financialAdministration.overview.confirmedNetAmount': 'Neto confirmado',
  'financialAdministration.overview.grossAmount': 'Bruto',
  'financialAdministration.overview.taxAmount': 'Impuesto',
  'financialAdministration.overview.discountAmount': 'Descuento',
  'financialAdministration.overview.commissionGeneratedGross': 'Comisión generada',
  'financialAdministration.overview.omittedCommissionGross': 'Omitida',
  'financialAdministration.overview.notYetDue': 'Aún no vence',
  'financialAdministration.overview.duePendingApproval': 'Vence y falta aprobar',
  'financialAdministration.overview.eligibleUnsettledGross': 'Elegible sin liquidar',
  'financialAdministration.overview.inSettlementGross': 'En liquidación',
  'financialAdministration.overview.paidCommissionGross': 'Comisión pagada',
  'financialAdministration.overview.openSettlementGross': 'Bruto de liquidación abierta',
  'financialAdministration.overview.openSettlementAdjustments': 'Ajustes de liquidación abierta',
  'financialAdministration.overview.settlementNetPayable': 'Neto a pagar abierto',
  'financialAdministration.overview.paidSettlementGross': 'Bruto de liquidación pagada',
  'financialAdministration.overview.paidSettlementAdjustments': 'Ajustes de liquidación pagada',
  'financialAdministration.overview.paidNetPayable': 'Neto pagado',
  'financialAdministration.overview.inconsistentCount': 'Cantidad inconsistente',
  'financialAdministration.overview.inconsistentAmount': 'Importe inconsistente',
  'financialAdministration.derivedState.notYetDue': 'Aún no vence',
  'financialAdministration.derivedState.duePendingApproval': 'Ya venció y falta el pase a aprobada',
  'financialAdministration.derivedState.eligibleUnsettled': 'Elegible, sin liquidar',
  'financialAdministration.derivedState.inSettlement': 'Dentro de una liquidación',
  'financialAdministration.derivedState.paid': 'Pagada',
  'financialAdministration.derivedState.omitted': 'Omitida (actor suspendido)',
  'financialAdministration.derivedState.cancelled': 'Cancelada',
  'financialAdministration.derivedState.reversed': 'Revertida',
  'financialAdministration.derivedState.inconsistent': 'Inconsistente',
  'financialAdministration.paymentDisposition.payable': 'Pagable',
  'financialAdministration.paymentDisposition.omittedActorSuspended': 'Omitida — actor suspendido',
  'financialAdministration.ledgerStatus.pending': 'Pendiente',
  'financialAdministration.ledgerStatus.approved': 'Aprobada',
  'financialAdministration.ledgerStatus.settled': 'Liquidada',
  'financialAdministration.ledgerStatus.paid': 'Pagada',
  'financialAdministration.ledgerStatus.cancelled': 'Cancelada',
  'financialAdministration.ledgerStatus.reversed': 'Revertida',
  'financialAdministration.settlementStatus.draft': 'Borrador',
  'financialAdministration.settlementStatus.pendingReview': 'Pendiente de revisión',
  'financialAdministration.settlementStatus.approved': 'Aprobada',
  'financialAdministration.settlementStatus.paid': 'Pagada',
  'financialAdministration.settlementStatus.cancelled': 'Cancelada',
  'financialAdministration.columns.id': 'Id',
  'financialAdministration.columns.companyId': 'Empresa',
  'financialAdministration.columns.subscriptionId': 'Suscripción',
  'financialAdministration.columns.provider': 'Proveedor',
  'financialAdministration.columns.status': 'Estado',
  'financialAdministration.columns.currency': 'Moneda',
  'financialAdministration.columns.effectivePaymentDate': 'Pago efectivo',
  'financialAdministration.columns.billingPeriod': 'Período',
  'financialAdministration.columns.baseNetAmount': 'Base',
  'financialAdministration.columns.discountAmount': 'Descuento',
  'financialAdministration.columns.netAmount': 'Neto',
  'financialAdministration.columns.taxAmount': 'Impuesto',
  'financialAdministration.columns.grossAmount': 'Bruto',
  'financialAdministration.columns.mrrAmount': 'MRR',
  'financialAdministration.columns.derivedState': 'Estado derivado',
  'financialAdministration.columns.ruleFrequencyType': 'Frecuencia',
  'financialAdministration.columns.beneficiary': 'Beneficiario',
  'financialAdministration.columns.customer': 'Cliente',
  'financialAdministration.columns.agreement': 'Acuerdo',
  'financialAdministration.columns.revenueType': 'Ingreso',
  'financialAdministration.columns.commissionAmount': 'Comisión',
  'financialAdministration.columns.effectiveSaleDate': 'Fecha de venta',
  'financialAdministration.columns.eligibilityDate': 'Elegibilidad',
  'financialAdministration.columns.settlementId': 'Liquidación',
  'financialAdministration.columns.generatedAt': 'Generada',
  'financialAdministration.columns.paidAt': 'Pagada',
  'financialAdministration.columns.period': 'Período',
  'financialAdministration.columns.grossCommissionAmount': 'Comisión bruta',
  'financialAdministration.columns.adjustmentsAmount': 'Ajustes',
  'financialAdministration.columns.netPayableAmount': 'Neto a pagar',
  'financialAdministration.columns.settlementFrequency': 'Frecuencia',
  'financialAdministration.columns.commissionLedgerId': 'Obligación',
  'financialAdministration.columns.adjustmentAmount': 'Ajuste',
  'financialAdministration.columns.finalAmount': 'Final',
  'financialAdministration.detail.payment': 'Pago',
  'configForm.hero.summary.resource.financialAdministrationPayment.details':
    'del pago seleccionado',
  'configForm.hero.summary.resource.financialAdministrationLedger.details':
    'de la obligación seleccionada',
  'configForm.hero.summary.resource.financialAdministrationSettlement.details':
    'de la liquidación seleccionada',
  'financialAdministration.detail.openBeneficiary': 'Historial del beneficiario',
  'financialAdministration.detail.resolutionTrace': 'Trace de resolución',
  'financialAdministration.detail.items': 'Líneas de liquidación',
  'financialAdministration.detail.itemsSummary': 'Líneas guardadas de la liquidación seleccionada.',
  'financialAdministration.detail.discountAssignment': 'Asignación de descuento',
  'financialAdministration.detail.discountAgreement': 'Plantilla de descuento',
  'financialAdministration.detail.discountLoading': 'Cargando descuento…',
  'financialAdministration.detail.discountMissing':
    'No se encontró la asignación de descuento guardada.',
  'financialAdministration.detail.paymentDisposition': 'Disposición de pago',
  'financialAdministration.detail.ledgerStatus': 'Estado del ledger',
  'financialAdministration.beneficiary.totals': 'Totales de comisión',
  'financialAdministration.beneficiary.ledgers': 'Obligaciones',
  'financialAdministration.beneficiary.settlements': 'Liquidaciones',
  'financialAdministration.beneficiary.load': 'Cargar historial',
  'financialAdministration.beneficiary.commissionGenerated': 'Comisión generada',
  'financialAdministration.beneficiary.notYetDue': 'Aún no vence',
  'financialAdministration.beneficiary.duePendingApproval': 'Vence y falta aprobar',
  'financialAdministration.beneficiary.eligibleUnsettled': 'Elegible sin liquidar',
  'financialAdministration.beneficiary.inSettlement': 'En liquidación',
  'financialAdministration.beneficiary.paidCommission': 'Comisión pagada',
  'financialAdministration.beneficiary.omitted': 'Omitida',
  'financialAdministration.beneficiary.openSettlementGross': 'Bruto de liquidación abierta',
  'financialAdministration.beneficiary.openSettlementAdjustments': 'Ajustes de liquidación abierta',
  'financialAdministration.beneficiary.openSettlementNetPayable': 'Neto a pagar abierto',
  'financialAdministration.beneficiary.paidSettlementGross': 'Bruto de liquidación pagada',
  'financialAdministration.beneficiary.paidSettlementAdjustments': 'Ajustes de liquidación pagada',
  'financialAdministration.beneficiary.paidNetPayable': 'Neto pagado',
  'financialAdministration.ruleFrequency.recurring': 'Recurrente',
  'financialAdministration.ruleFrequency.oneTime': 'Única',
  'financialAdministration.ruleFrequency.empty': '—',
  'financialAdministration.provider.stripe': 'Stripe',
  'financialAdministration.provider.bankTransfer': 'Transferencia bancaria',
  'financialAdministration.provider.manual': 'Manual',
  'financialAdministration.paymentStatus.pending': 'Pendiente',
  'financialAdministration.paymentStatus.requiresAction': 'Requiere acción',
  'financialAdministration.paymentStatus.processing': 'Procesando',
  'financialAdministration.paymentStatus.paid': 'Pagado',
  'financialAdministration.paymentStatus.failed': 'Fallido',
  'financialAdministration.paymentStatus.cancelled': 'Cancelado',
  'financialAdministration.paymentStatus.refunded': 'Reembolsado',
  'financialAdministration.paymentStatus.partiallyRefunded': 'Reembolso parcial',
};
